import React from "react";
// import { useHistory } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    // const history = useHistory();
    const [login] = React.useState(localStorage.getItem("isSession") || "false");
    const [userRole] = React.useState(localStorage.getItem("CloudUserType") ? localStorage.getItem("CloudUserType") : '');
    
    React.useEffect(() => {
    }, [userRole]);

    const url = window.location.pathname;
    if (!userRole) {
        if (window.location.hash.includes("/admindashboard")) {
            window.location.replace(url + "#/adminlogin");
        } else if (window.location.hash === "#/clouddashboard") {
            window.location.replace(url + "#/cloudlogin");
        }
        else if (window.location.hash === "#/property-manager-dashboard") {
            window.location.replace(url + "#/cloudlogin");
        }
        else if (window.location.hash === "#/property-manager-dashboard/settings/users") {
            window.location.replace(url + "#/cloudlogin");
        }
        else if (window.location.hash === "#/property-manager-dashboard/settings/subscription") {
            window.location.replace(url + "#/cloudlogin");
        }
        else if (window.location.hash === "#/property-manager-dashboard/settings/storage") {
            window.location.replace(url + "#/cloudlogin");
        }
        else if (window.location.hash === "#/dashboard") {
            window.location.replace(url + "#/cloudlogin");
        } else if (window.location.hash === "#/uploadfile") {
            window.location.replace(url + "#/cloudlogin");
        } else if (window.location.hash === "#/about") {
            window.location.replace(url + "#/cloudlogin");
        } else if (window.location.hash === "#/faq") {
            window.location.replace(url + "#/cloudlogin");
        } else if (window.location.hash === "#/content") {
            window.location.replace(url + "#/cloudlogin");
            // new design
        } else if (window.location.hash === "#/rulesdashboard") {
            window.location.replace(url + "#/cloudlogin");
        } else if (window.location.hash === "#/propertychannle") {
            window.location.replace(url + "#/cloudlogin");
        }

        //rulesdashboard -------
        if (window.location.hash.includes("#/content")) {
            const idContainer = window.location.hash.split("/");
            if (idContainer[2] != "") {
                window.location.replace(url + "#/cloudlogin");
            }
        }
        // new design
        if (window.location.hash.includes("#/propertychannle")) {
            const idContainer = window.location.hash.split("/");
            if (idContainer[2] != "") {
                window.location.replace(url + "#/cloudlogin");
            }
        }


        // -------
    } else {
        if (login === "true") {
            if (userRole === "admin" && localStorage.getItem("dataFirst") == "true") {
                window.location.replace(url + "#/admindashboard/changepassword");
            }

            else if (userRole === "property_manager") {
                window.location.replace(url + "#/property-manager-dashboard")
            }

            else if ((userRole === "property_manager") && window.location.hash === "#/adminlogin") {
                window.location.replace(url + "#/property-manager-dashboard")
            }

            else if ((userRole === "property_manager") && window.location.hash === "#/property-manager-dashboard") {
                window.location.replace(url + window.location.hash)
            }
            // cloud user  
            else if ((userRole === "clouduser" || userRole === "property_user" || userRole === "admin") && window.location.hash === "#/content") {
                window.location.replace(url + window.location.hash);
            } else if ((userRole === "clouduser" || userRole === "property_user") && window.location.hash === "#/clouddashboard") {
                window.location.replace(url + window.location.hash);
                // new design
            } else if ((userRole === "clouduser" || userRole === "property_user") && window.location.hash === "#/propertychannle") {
                window.location.replace(url + window.location.hash);
            } else if ((userRole === "clouduser" || userRole === "property_user") && window.location.hash === "#/rulesdashboard") {
                window.location.replace(url + window.location.hash);
                // -----------//
            }
            else if ((userRole === "admin") && window.location.hash === "#/property-manager-dashboard"){
                 window.location.replace(url + "#/admindashboard")
            }
            else if (((userRole === "admin") && window.location.hash === "#/property-manager-dashboard/settings/users")){
                window.location.replace(url + "#/admindashboard")
            }
            else if (((userRole === "admin") && window.location.hash === "#/property-manager-dashboard/settings/subscription")){
                window.location.replace(url + "#/admindashboard")
            }
            else if (((userRole === "admin") && window.location.hash === "#/property-manager-dashboard/settings/storage")){
                window.location.replace(url + "#/admindashboard")
            }
            // else if ((userRole === "normal") && window.location.hash === "#/dashboard") {
            //     window.location.replace(url + window.location.hash);
            // }
            else if (userRole === "admin" && window.location.hash.includes("#/admindashboard")) {
                window.location.replace(url + window.location.hash);
            } else if ((userRole === "clouduser" || userRole === "property_user") && window.location.hash === "#/uploadfile") {
                window.location.replace(url + "#/uploadfile");
            } else if ((userRole === "clouduser" || userRole === "property_user") && window.location.hash === "#/about") {
                window.location.replace(url + "#/about");
            } else if ((userRole === "clouduser" || userRole === "property_user") && window.location.hash === "#/faq") {
                window.location.replace(url + "#/faq");
            }
        }
    }
    return children;
};

export default ProtectedRoute;
